module.exports = __webpack_public_path__ + "img/referral_1.56517999.jpeg";